import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import React from "react";
import CurrencyFormat from "react-currency-format";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function PackageCard({ data, handleChange, getQuotation, goBack }) {

    function going() {
        getQuotation()
    }

    return (
        <form onSubmit={evt => going()}>
            <div className="row">
                <div className="col-md-12">
                    <div className="block block-rounded block-bordered block-fx-pop">
                        <div className="block-header">
                            <div className="block-title">
                                Informações do pacote
                            </div>
                        </div>
                        <div className="block-content">
                            <div className="block-content row">
                                <div className="form-group col-4">
                                    <span>{Translate(Message.Height)} da caixa (cm)</span>
                                    <input type="number" className="form-control" name="height" value={data && data.height} onChange={evt => handleChange(evt, FieldTypeObj.Number)} />
                                </div>
                                <div className="form-group col-4">
                                    <span>{Translate(Message.Width)} da caixa (cm)</span>
                                    <input type="number" className="form-control" name="width" value={data && data.width} onChange={evt => handleChange(evt, FieldTypeObj.Number)} />
                                </div>
                                <div className="form-group col-4">
                                    <span>{Translate(Message.Depth)} da caixa (cm)</span>
                                    <input type="number" className="form-control" name="depth" value={data && data.depth} onChange={evt => handleChange(evt, FieldTypeObj.Number)} />
                                </div>
                                <div className="form-group col-6">
                                    <span>{Translate(Message.Weigth)} (Kg)</span>
                                    <input type="number" className="form-control" name="weight" value={data && data.weight} onChange={evt => handleChange(evt, FieldTypeObj.Number)} />
                                </div>
                                <div className="form-group col-6">
                                    <span>Qual é o valor do item?
                                        <br />
                                        <small>O item será assegurado no valor definido por você logo abaixo.</small>
                                    </span>
                                    <CurrencyFormat
                                        className={`form-control`}
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        name="declaredValue"
                                        value={data.declaredValue}
                                        prefix={"R$"}
                                        onValueChange={(values) => {
                                            const { formattedValue, value } = values;
                                            handleChange(
                                                { target: { value: value, name: "declaredValue" } }, FieldTypeObj.Decimal
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 text-center">
                    {goBack != undefined ?
                        <button type="button" className="btn btn-hero-lg btn-hero-white text-warning" onClick={() => goBack()}>
                            Voltar
                        </button>
                        : ""}
                    <button type="button" className="btn btn-hero-lg btn-hero-success" onClick={() => going()}>
                        Avançar
                    </button>
                </div>
            </div>
        </form>
    )
}